import {Injectable} from "@angular/core";
import {JwtHttpClientService} from "../http/jwt-http-client.service";
import {firstValueFrom, map} from "rxjs";
import {HttpResponse} from "@angular/common/http";

export interface Image {
    id: number;
    image: string;
}

/**
 * Retrieves images from the server
 */
@Injectable()
export class ImageService {

    public static readonly URL = "/dataserver/image/";

    constructor(private http: JwtHttpClientService) {
    }

    public async getImage(imageId: number): Promise<string> {
        return firstValueFrom(this.http.get(ImageService.URL + imageId.toString(), undefined, undefined, "text").pipe(
            map((response: HttpResponse<string>) => response.body || undefined)
        ));
    }

    public async lazyLoadImage(image: Image): Promise<string> {
        if (!image || !image.id) {
            return undefined;
        }

        if (image.image === undefined) {
            const imageId: number = image.id;
            image.image = null; // Avoid concurrent reloading - note that this may wipe image.id
            image.image = await this.getImage(imageId);
            if (image.image) {
                image.id = imageId;
            } else {
                image.id = undefined;
            }
        }
        return image.image;
    }
}
